module.exports = __webpack_public_path__ + "static/img/book44.ceeb9c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book44.jpg
// module id = VV0Z
// module chunks = 1